import { FC } from 'react'

import { useNavigationContext } from 'context/navigation-context'
import { Submenu as StyledSubmenu, SubmenuItem } from './styled'

export const Submenu: FC<{ onClick: () => void }> = ({ onClick }) => {
  const { sections } = useNavigationContext()

  const handleScroll = (sectionElement: HTMLDivElement) => {
    onClick()

    // Without the delay (any value worked while I waas testing),
    // the scrolling did not trigger in some browsers unless
    // onClick() call was omitted
    setTimeout(() => {
      sectionElement.scrollIntoView()
    }, 0)
  }

  return (
    <>
      {!!sections.length && (
        <StyledSubmenu>
          {sections.map((section) => (
            <SubmenuItem key={section.title}>
              <button onClick={() => handleScroll(section.element)}>
                {section.title}
              </button>
            </SubmenuItem>
          ))}
        </StyledSubmenu>
      )}
    </>
  )
}
